import React, { useEffect, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { FaNewspaper, FaPlus } from "react-icons/fa6";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import PatientModal from "../../Modal/PatientModal/PatientModal";
import { useDispatch, useSelector } from "react-redux";
import {
  getPatientAction,
  updateAssignPatientInfoAction,
} from "../../Actions/PatientActions/PatientAction";
import { IoIosArrowBack } from "react-icons/io";
import ReactPaginate from "react-paginate";
import { useNavigate } from "react-router-dom";
import { MdOutlineAssignmentReturned } from "react-icons/md";
import { TbPlayerEject } from "react-icons/tb";
import RejectModal from "../../Modal/RejectModal/RejectModal";
import { createVisitAction } from "../../Actions/VisitAction/VisitAction";
import swal from "sweetalert";
import LoadingPage from "../Loading/LoadingPage";
import Pagination from "../Pagination";

const Patient = () => {
  const navigate = useNavigate();
  const [patientId, setPatientId] = useState(null);
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Gender",
      name: "gender",
    },
    {
      label: "phone",
      name: "phone",
    },
    {
      label: "birth date",
      name: "birthDate",
    },

    {
      label: "Date",
      name: "date",
    },
  ];
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [isOpenPatientModal, setIsOpenPatientModal] = useState(false);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getPatientAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        [0, 1, 2],
        [0, 1],
        0
      )
    );
  }, [perPage]);
  const getPatient = useSelector((state) => state.getPatient);
  const { patients, total, loading } = getPatient;

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(
      getPatientAction(
        event.selected + 1,
        perPage,
        filter.fullname,
        filter.phone,
        filter.code,
        filter.from,
        filter.to,
        [0, 1, 2],
        [0, 1],
        0
      )
    );
  };
  const [isOpenReject, setIsOpenReject] = useState(false);
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    gender: "",
    phone: "",
    birthDate: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getPatientAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        [0, 1, 2],
        [0, 1],
        0
      )
    );
    setIsOpenFilter(false);
  };
  const handleClearSearch = (name) => {
    const updateParams = { ...filter };
    setFilter(updateParams);
    updateParams[name]="";
    dispatch(
      getPatientAction(
        page,
        perPage,
        updateParams.fullname,
        updateParams.code,
        updateParams.gender,
        updateParams.phone,
        updateParams.birthDate,
        [0, 1, 2],
        [0, 1],
        0
      )
    );
    setIsOpenFilter(false);
  };

  const handleNewVisit = (patientId, patientInfoId) => {
    dispatch(createVisitAction(patientId));
    dispatch(updateAssignPatientInfoAction(patientInfoId, 0));
    swal({
      title: "Good job!",
      text: "New Visit was saved Successfully !",
      icon: "success",
      button: "OK",
      timer: 2000,
    });
    handleSearch();
    handleSearch();
  };
  return (
    <>
      <div className="parent">
        <div className="flex justify-between items-center p-2">
          <div>
            <p className="font-bold">Patient</p>
          </div>
          <div>
            <button
              className="btn-primary flex gap-2 items-center "
              onClick={() => setIsOpenPatientModal(true)}
            >
              Add Patient
              <p>
                <FaPlus />
              </p>
            </button>
          </div>
        </div>
        {loading ? (
          <LoadingPage />
        ) : (
          <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button onClick={()=>handleClearSearch(th.name)} className="btn-danger px-1.5 py-1">
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                    <th className="coustm-th">Visits </th>
                    <th className="coustm-th">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {patients?.map((patient, index) => {
                    return (
                      <tr
                        className={
                          patient.patient_info.assign == 1
                            ? "coustm-tr bg-indigo-500 bg-opacity-40"
                            : patient.patient_info.assign == 2
                            ? "coustm-tr bg-green-500 bg-opacity-40"
                            : "coustm-tr"
                        }
                        key={index}
                      >
                        <td className="coustm-td">{index + 1}</td>

                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.code}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.fullname}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.gender}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.phone}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.birth_date}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.created_at.toString().split("T")[0]}
                        </td>
                        <td
                          onClick={() => navigate("/medicalForm/" + patient.id)}
                          className="coustm-td text-red-600 underline text-lg font-bold text-center"
                        >
                          {" "}
                          {patient.count_visits_with_approve}
                        </td>
                        <td className="coustm-td">
                          <div className="flex gap-2 justify-center">
                            {patient.patient_info.assign == 0 ||
                            patient.patient_info.assign == 1 ? (
                              <>
                                <button
                                  className="btn-blue mb-0 "
                                  onClick={() =>
                                    navigate("/medicalForm/" + patient.id)
                                  }
                                  title="Assign"
                                >
                                  <MdOutlineAssignmentReturned />
                                </button>
                                <button
                                  className="btn-red mb-0"
                                  title="Reject"
                                  onClick={() => {
                                    setIsOpenReject(true);
                                    setPatientId(patient.id);
                                  }}
                                >
                                  <TbPlayerEject />
                                </button>
                              </>
                            ) : (
                              <button
                                onClick={(e) =>
                                  handleNewVisit(
                                    patient.id,
                                    patient.patient_info.id
                                  )
                                }
                                className="btn-indigo mb-0"
                                title="New Visit"
                              >
                                <FaNewspaper />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <Pagination
          perPage={perPage}
          setPerPage={setPerPage}
          page={page}
          total={total}
          onPageChange={onPageChange}
        />
      </div>

      {isOpenPatientModal && (
        <PatientModal
          isOpen={isOpenPatientModal}
          onClose={setIsOpenPatientModal}
        />
      )}

      {isOpenReject && (
        <RejectModal
          closeModal={() => setIsOpenReject(false)}
          patientId={patientId}
        />
      )}

      <div className="bottom-space"></div>
    </>
  );
};

export default Patient;